/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tracked/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaCheckboxWithInputText from 'DesignSystem/TysiaCheckboxWithInputText/index'



/** @type {import('Simple/types.js').View} */
export default function Tracked({
  children,
  viewPath = "/DesignSystem/Data/DataVaxiom/DataVaxiomTxCardFieldDefinitions/DataVaxiomTxCardFieldDefinitionsCardWrite/Tracked",
  onChange,
  isSubmitting
  
}) {
let txCardFieldDefinitionTrackedValueData = fromData.useDataValue({ viewPath,
context: 'tx_card_field_definition',
path: 'tracked',
})
let txCardFieldDefinitionTrackedChangeData = fromData.useDataChange({ viewPath,
context: 'tx_card_field_definition',
path: 'tracked',
})
let txCardFieldDefinitionTrackedIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'tx_card_field_definition',
})
  return (<React.Fragment
>
<TysiaCheckboxWithInputText
  viewPath={`${viewPath}/TysiaCheckboxWithInputText`}
 text="Tracked"
 data="tx_card_field_definition.tracked"
 value={txCardFieldDefinitionTrackedValueData}
 onChange={txCardFieldDefinitionTrackedChangeData}
 disabled={txCardFieldDefinitionTrackedIsSubmittingData}
/>
{children}
</React.Fragment>)
}